import { render, staticRenderFns } from "./Getter.vue?vue&type=template&id=848715b0&"
import script from "./Getter.vue?vue&type=script&lang=js&"
export * from "./Getter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports